module.exports = __webpack_public_path__ + "static/media/slide-2.9b2a3212.jpg";